import { cn } from '@/libs/tw'

import { ContentContainer } from './contentContainer'

type PageContainerProps = {
	id: string
	className?: string
	children: JSX.Element
	separator?: boolean
	largePadding?: boolean
}

export const PageContainer = ({ id, className, children, largePadding }: PageContainerProps) => {
	return (
		<section
			id={id}
			className={cn(
				'flex w-full items-center justify-center py-24',
				largePadding && 'py-56',
				className
			)}
		>
			<ContentContainer>{children}</ContentContainer>
		</section>
	)
}
